import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'LIVEINTERVIEW_REVIEW_SAVE_ERROR':
      return action.error;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'LIVEINTERVIEW_REVIEW_SAVE_LOADING':
      return action.loading;

    default:
      return state;
  }
}

export function saved(state = null, action) {
  switch (action.type) {
    case 'LIVEINTERVIEW_REVIEW_SAVE_SUCCESS':
      return action.saved;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, saved });
